import React from 'react';
import { FINISH_STEP, GO_BACK_TO_STEP, } from '../../storage/TutorialReducer';
import { withRouter } from 'react-router-dom';

class TutorialStep4 extends React.Component {
  componentDidMount () {
    if (this.props.location.pathname !== '/coin') {
      this.props.history.push('/coin');
    }
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 4});
  }

  goBack () {
    Storage.dispatch({type: GO_BACK_TO_STEP, payload: 3});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2 className="c-tutorial-element__subtitle">
          Coins page
        </h2>
        <p>
          Here you can transfer AsyncCoin to another address, or even buy ASC with ETH, of course if the contract owner
          allows it. If you want to buy ASC with Ether please hit us up on: <code>coin@asynclabs.co</code>
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goBack}>Back</button>
          <button onClick={this.goNext}>Next</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TutorialStep4);



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep4.js